import { Box, Button, Divider, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FC, MouseEvent, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCustomNavigate } from 'utils/hooks/useCustomNavigate';
import { getDrawerWidth } from 'utils/validators/HelperFunctions';
import strings from '../../common/Translation/Translate';
import DrawerMenu from '../../components/DrawerMenu';
import PageLoader from '../../components/PageLoader';
import axiosInstance from '../../utils/axios';
import { URLS } from '../../utils/constants/urls';
import { getTheme, setTheme } from '../../utils/redux/reducer/authentication-slice';
type CustomeThemeProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};
const CustomTheme: FC<CustomeThemeProps> = ({ open, setOpen }) => {
  const theme = useSelector(getTheme);
  const defaultTheme = useTheme();
  const screenSizeDownSm = useMediaQuery(defaultTheme.breakpoints.down('sm'));
  const screenSizeDownMd = useMediaQuery(defaultTheme.breakpoints.down('md'));
  const screenSizeUpLg = useMediaQuery(defaultTheme.breakpoints.up('lg'));
  const Navigate = useCustomNavigate();
  const dispatch = useDispatch();
  const [themeObj, setThemeObj] = useState<any>(theme);
  const [loading, setLoading] = useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
  };
  const setForm = useMemo(() => {
    const handleSave = async (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      try {
        setLoading(true);
        const { status }: { status: number } = await axiosInstance.post(URLS.setTheme, themeObj);
        if (status === 200) {
          setLoading(false);
          dispatch(setTheme(themeObj));
          setOpen(false);
          Navigate('/');
        }
      } catch (e) {
        setLoading(false);
      }
    };
    const handleOnChange = (e: any, type: string) => {
      const value = e.target.value;
      switch (type) {
        case 'primary':
          setThemeObj({ ...themeObj, primary: value });
          break;
        case 'secondary':
          setThemeObj({ ...themeObj, secondary: value });
          break;
        case 'primaryTextColor':
          setThemeObj({ ...themeObj, primaryTextColor: value });
          break;
        case 'secondaryTextColor':
          setThemeObj({ ...themeObj, secondaryTextColor: value });
          break;
        case 'logoBackgroundColor':
          setThemeObj({ ...themeObj, logoBackgroundColor: value });
          break;
        default:
      }
    };
    return (
      <Box p={1} width="100%">
        <Grid direction="column" container>
          <Grid mb={2}>
            <Typography variant="subtitle2" mb={1}>
              {strings.theme_primary_color} ({themeObj.primary})
            </Typography>
            <input
              onChange={e => handleOnChange(e, 'primary')}
              type="color"
              id="favcolor"
              name="favcolor"
              value={themeObj.primary}
            />
          </Grid>
          <Grid mb={2}>
            <Typography variant="subtitle2" mb={1}>
              {strings.theme_primary_text_color} ({themeObj.primaryTextColor})
            </Typography>
            <input
              onChange={e => handleOnChange(e, 'primaryTextColor')}
              type="color"
              id="favcolor"
              name="favcolor"
              value={themeObj.primaryTextColor}
            />
          </Grid>
          <Grid mb={2}>
            <Typography variant="subtitle2" mb={1}>
              {strings.theme_secondary_color} ({themeObj.secondary})
            </Typography>
            <input
              onChange={e => handleOnChange(e, 'secondary')}
              type="color"
              id="favcolor"
              name="favcolor"
              value={themeObj.secondary}
            />
          </Grid>
          <Grid mb={2}>
            <Typography variant="subtitle2" mb={1}>
              {strings.theme_secondary_text_color} ({themeObj.secondaryTextColor})
            </Typography>
            <input
              onChange={e => handleOnChange(e, 'secondaryTextColor')}
              type="color"
              id="favcolor"
              name="favcolor"
              value={themeObj.secondaryTextColor}
            />
          </Grid>
          <Grid mb={2}>
            <Typography variant="subtitle2" mb={1}>
              {strings.theme_logo_background_color} ({themeObj.logoBackgroundColor})
            </Typography>
            <input
              onChange={e => handleOnChange(e, 'logoBackgroundColor')}
              type="color"
              id="favcolor"
              name="favcolor"
              value={themeObj.logoBackgroundColor}
            />
          </Grid>
        </Grid>
        <Divider />
        <Grid container sx={{ my: 3 }}>
          <Button variant="contained" onClick={e => handleSave(e)}>
            {strings.theme_button_text}
          </Button>
        </Grid>
      </Box>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, setOpen, themeObj]);

  return (
    <>
      {loading && <PageLoader />}
      <DrawerMenu
        open={open}
        width={getDrawerWidth(screenSizeDownSm, screenSizeDownMd, screenSizeUpLg)}
        handleClose={handleClose}
        closeButton={true}
        overlapHeader
        title="Admin Theme">
        {setForm}
      </DrawerMenu>
    </>
  );
};
export default CustomTheme;
